import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ConfigitAceAssignment, ConfigitAceConfiguration, ConfigitAceConfigureParams } from './configit-ace.model';
import { Observable } from 'rxjs';

export interface ConfigureParams {
    salesOrg: string;
    language: string;
    assignments?: ConfigitAceAssignment[];
}

export interface BomClassification {
    id: string;
    values: string[];
}

export interface BomQuantity {
    id: string;
    quantity: number;
}

export interface BomSolveParams {
    application: string;
    salesOrg: string;
    classifications: BomClassification[];
    quantities?: {
        categoryQuantities?: BomQuantity[];
        itemQuantities?: BomQuantity[];
    };
}

interface BomSolveResponse {
    bomItems: {
        id: string;
        quantity: number;
    }[];
}

@Injectable({
    providedIn: 'root',
})
export class ConfigitAceApiService {
    constructor(private http: HttpClient) {}

    private configureParams(
        productId: string,
        { salesOrg, language, assignments }: ConfigureParams
    ): ConfigitAceConfigureParams {
        return {
            date: new Date().toISOString(),
            language,
            globalArguments: {
                SalesArea: {
                    SalesOrganization: salesOrg,
                    DistributionChannel: '01',
                    SalesDivision: '01',
                },
                Plant: salesOrg,
            },
            settings: {
                includeConfiguration: true,
                includeMinimalConflictSet: true,
            },
            line: { productId, variableAssignments: assignments || [] },
            viewId: 'STANDARDVIEW',
        };
    }

    public configure(id: string, params: ConfigureParams): Observable<ConfigitAceConfiguration> {
        const body = this.configureParams(id, params);
        return this.http.post<ConfigitAceConfiguration>(`${environment.configit.baseUrl}/configure`, body, {
            params: { packagePath: `Internal/master/${id}` },
        });
    }

    public bomSolve(params: BomSolveParams): Observable<BomSolveResponse> {
        const url = `${environment.quotation}/bom/${params.application}/solve`;
        const { classifications, quantities } = params;
        const body = { classifications, quantities };
        return this.http.post<BomSolveResponse>(url, body, {
            params: {
                salesorg: params.salesOrg,
                country: environment.configit.country,
            },
        });
    }
}
